export const fallbackTaskColor = '#E6E6E6';